<template>
    <div>

        <div class="col-form-label" v-show="value[1] || value[0]">  {{value[0]}} - {{value[1]}} &nbsp;
            <i @click="reset" class="fa fa-remove"></i></div>
        <dropdown-confirmation
                v-show="!value[0] && !value[1]"
                name="latest_comms_filter"
                size="lg"
                direction="right"
                :styleObj = "styleObj"
                triggerBtnClass="btn-clear"
                triggerBtnHtml='<i class="fa fa-sliders"></i>'
                confirmBtnClass="btn-primary"
                confirmBtnHtml='<i class="fa fa-check"></i>&nbsp;&nbsp;OK'
                @confirm="setValues"
        >
            <slot>
                <div class="inline-input-holder">
                    <div class="input-group" >
                        <div class="input-group-addon" v-if="label == '$'">
                            <i class="fa fa-dollar"></i>
                        </div>
                        <input placeholder="Min" type="text" v-model.lazy="min" class="form-control" />
                        <div class="input-group-addon" v-if="label == '%'">
                            <i class="fa fa-percent"></i>
                        </div>
                    </div>
                </div>
                <span>-&nbsp;&nbsp;</span>
                <div class="inline-input-holder">
                    <div class="input-group" >
                        <div class="input-group-addon" v-if="label == '$'">
                            <i class="fa fa-dollar"></i>
                        </div>
                        <input  v-model.lazy="max" type="text" class="form-control" placeholder="Max" />
                        <div class="input-group-addon" v-if="label == '%'">
                            <i class="fa fa-percent"></i>
                        </div>
                    </div>
                </div>
            </slot>
        </dropdown-confirmation>

    </div>

</template>
<script type="text/babel">
    import Dropdown from '../assets/Dropdown.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: "RangeFilter",
        data() {
            return {
                todaysDate:{
                    to: new Date().setHours(23,59,59,999),
                    from: new Date().setHours(0,0,0,0)
                },
                min: null,
                max: null,
                styleObj:{
                    width: '320px',
                    textAlign: 'right'
                }

            }
        },
        components:{
            DropdownConfirmation,
            Dropdown,
            Datepicker
        },
        computed:{

        },
        methods:{
            setValues(){
                this.$set(this.value, 0, this.min);
                this.$set(this.value, 1, this.max);

            },
            reset(){

                this.min = null;
                this.max = null;
                this.$emit('input',  [null,null] )
            }
        },
        props: {
            value:{
                type: Array,
                required: true
            },
            label:{
                type: String,
                required: false
            }
        }
    }
</script>
<style>
    .inline-input-holder{
        display:inline-block; width: 125px;
    }
</style>


// WEBPACK FOOTER //
// RangeFilter.vue?538d42ab